import { useParams } from "react-router-dom";
import useUserState from "ui/adapter/state/useUserState";

export default function usePartnerAddressAndBackButton(): { partnerAddress: string; shouldShowBackButton: boolean } {
    const { partnerAddress } = useParams();
    const { selectedRole } = useUserState();
    const safePartnerAddress = selectedRole?.partner?.address as string;

    if (partnerAddress) return { partnerAddress, shouldShowBackButton: true };
    return { partnerAddress: safePartnerAddress, shouldShowBackButton: false };
}
